import type { HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Resolve } from '@angular/router';
import type { Observable } from 'rxjs';

import type { Profile } from '../models/profile';
import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionResolver implements Resolve<{
  res: HttpResponse<{ data: Profile }>;
  profilePicture: string;
}> {
  permissionService = inject(PermissionService);

  resolve(): Observable<{
    res: HttpResponse<{ data: Profile }>;
    profilePicture: string;
  }> {
    return this.permissionService.loadPermissions();
  }
}
